import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const normalizeList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.rows)) {
    return payload.rows;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  return [];
};

const normalizeMainRow = (row, index) => ({
  ...row,
  daysLeftToApprovePriority: row.prioritySlaDaysRemaining ?? row.daysLeftToApprovePriority ?? row.priorityDaysLeft,
  daysLeftToApproveRegular: row.regularSlaDaysRemaining ?? row.daysLeftToApproveRegular ?? row.regularDaysLeft,
  lastDateToApprove: row.lastDateToApprove ?? row.lastApprovalDate ?? row.lastDate ?? row.approvalDate ?? null,
  id: row.id || row.detailId || `${row.batchId || "dc-cost-main"}-${index}`,
});

const normalizeDCCostMainPage = (payload, fallbackPage = 0, fallbackSize = 10) => {
  const rows = normalizeDCCostMainRows(payload);
  const pageSize = Number(payload?.size ?? payload?.pageSize ?? payload?.data?.size ?? fallbackSize);
  const totalElements = Number(payload?.totalElements ?? payload?.data?.totalElements ?? rows.length);
  const totalPages = Number(
    payload?.totalPages ?? payload?.data?.totalPages ?? (Number.isFinite(pageSize) && pageSize > 0 ? Math.ceil(totalElements / pageSize) : 0)
  );
  const currentPage = Number(payload?.currentPage ?? payload?.page ?? payload?.data?.currentPage ?? payload?.data?.page ?? fallbackPage);

  return {
    rows,
    totalPages: Number.isFinite(totalPages) ? totalPages : 0,
    totalElements: Number.isFinite(totalElements) ? totalElements : rows.length,
    currentPage: Number.isFinite(currentPage) ? currentPage : fallbackPage,
    pageSize: Number.isFinite(pageSize) ? pageSize : fallbackSize,
  };
};

export const normalizeDCCostMainRows = (payload) => {
  const rows = normalizeList(payload);

  if (!rows.length) {
    return [];
  }

  return rows.map((row, index) => normalizeMainRow(row, index));
};

export const getDCCostMainRows = async (page = 0, size = 10) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return {
      rows: [],
      totalPages: 0,
      totalElements: 0,
      currentPage: page,
      pageSize: size,
    };
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostMain}?page=${page}&size=${size}`;
  const response = await getAPI(apiUrl, tokenInfo);

  if (response.ok) {
    const payload = await response.json().catch(() => ({}));
    return normalizeDCCostMainPage(payload, page, size);
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to load DC cost main data.", { contactSupport: false });
  return {
    rows: [],
    totalPages: 0,
    totalElements: 0,
    currentPage: page,
    pageSize: size,
  };
};

export default getDCCostMainRows;
